import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Card, Row, Col, Table, Button, Form } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';
import { FaUserGraduate, FaUsers, FaBook, FaLayerGroup, FaBars, FaBell, FaCog, FaChalkboardTeacher, FaChartBar, FaSignOutAlt, FaUserPlus, FaClock, FaImages, FaDownload, FaQuestionCircle, FaCertificate } from 'react-icons/fa';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { useNavigate } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import TeacherAttendance from './TeacherAttendance';
import StudentAttendance from './StudentAttendance';
import StudentTimeTable from './StudentTimeTable';
import TeacherTimeTable from './TeacherTimeTable';
import AdmissionPage from './AdmissionPage';
import { getDatabase, ref as dbRef, onValue, push, update, remove } from 'firebase/database';
import { QRCodeCanvas } from "qrcode.react";
import StudentsManagement from './StudentsManagement';
import NoticesBoard from './NoticesBoard';
import Teachers from './Teachers';
import Courses from './Courses';
import Batches from './Batches';
import ExamManagement from './ExamManagement';
import AssignHomework from '../components/AssignHomework';
import { useAuth } from '../AuthContext';
import { getFirestore, collection, query, where, onSnapshot } from 'firebase/firestore';
import Gallery from './Gallery';
import AdminGallery from './AdminGallery';
import Download from './Download';
import AdminEnquiry from './AdminEnquiry';
import HomeworkPage from './HomeworkPage';
import QuestionsPage from './QuestionsPage';
import Certificate from './Certificate';
const summaryCards = [
  { color: '#ff7043', icon: <FaUserGraduate size={32} />, label: 'Total Students', valueKey: 'students' },
  { color: '#43a047', icon: <FaUsers size={32} />, label: 'Total Teachers', valueKey: 'employees' },
  { color: '#1976d2', icon: <FaBook size={32} />, label: 'Total Courses', valueKey: 'courses' },
  { color: '#7b1fa2', icon: <FaLayerGroup size={32} />, label: 'Total Batches', valueKey: 'batches' },
];

const sidebarLinks = [
  { icon: <FaChartBar />, label: 'Dashboard' },
  { icon: <FaUserGraduate />, label: 'Students' },
  { icon: <FaChalkboardTeacher />, label: 'Teachers' },
  { icon: <FaBook />, label: 'Courses' },
  { icon: <FaLayerGroup />, label: 'Batches' },
  { icon: <FaBell />, label: 'Notices' },
  { icon: <FaCog />, label: 'Settings' },
  { icon: <FaChartBar />, label: 'Attendance', submenu: [
      { label: 'Teacher Attendance' },
      { label: 'Student Attendance' },
    ] },
  { icon: <FaLayerGroup />, label: 'TimeTable', submenu: [
      { label: 'Teacher TimeTable' },
      { label: 'Student TimeTable' },
    ] },
  { icon: <FaUserPlus />, label: 'New Admission' },
  { icon: <FaBook />, label: 'Exams', submenu: [
      { label: 'Create Exam' },
      { label: 'Manage Exams' },
      { label: 'Results' },
      { label: 'Admit Cards' },
    ] },
  { icon: <FaBook />, label: 'Homework', submenu: [
      { label: 'Assign Homework' },
      { label: 'View Submissions' },
    ] },
  { icon: <FaBook />, label: 'Questions', submenu: [
      { label: 'Add Questions' },
      { label: 'Question Bank' },
    ] },
  { icon: <FaImages />, label: 'Gallery' },
  { icon: <FaDownload />, label: 'Download' },
  { icon: <FaQuestionCircle />, label: 'Enquiry' },
  { icon: <FaCertificate />, label: 'Certificate' },
];

const chartData = {
  labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  datasets: [
    {
      label: 'Attendance',
      backgroundColor: '#1976d2',
      borderRadius: 8,
      data: [12, 19, 10, 15, 17, 14, 20],
    },
  ],
};

const chartOptions = {
  plugins: { legend: { display: false } },
  scales: { y: { beginAtZero: true, ticks: { stepSize: 5 } } },
  responsive: true,
  maintainAspectRatio: false,
};

const tasks = [
  { desc: 'Fee report', priority: 'High', date: '2025-05-19', status: 'Pending', user: 'Aman Sinha' },
  { desc: 'Staff meet', priority: 'Medium', date: '2025-05-20', status: 'In Progress', user: 'Rakesh Kumar' },
  { desc: 'Result review', priority: 'Low', date: '2025-05-21', status: 'Done', user: 'Mahima Rathi' },
];

const AdminDashboard = () => {
  // State declarations
  const [adminName, setAdminName] = useState('');
  const [selectedSection, setSelectedSection] = useState('Dashboard');
  const [counts, setCounts] = useState({
    students: 0,
    employees: 0,
    courses: 0,
    batches: 0
  });

  const [timeTableSummary, setTimeTableSummary] = useState([
    { icon: <FaBook size={28} />, label: 'Student TimeTables', value: 6, color: '#7b1fa2' },
    { icon: <FaChalkboardTeacher size={28} />, label: 'Teacher TimeTables', value: 5, color: '#1976d2' }
  ]);

  const [attendanceSummary, setAttendanceSummary] = useState([
    { icon: <FaUserGraduate size={28} />, label: 'Total Students Present', value: 18, color: '#43a047' },
    { icon: <FaChalkboardTeacher size={28} />, label: 'Total Teachers Present', value: 12, color: '#1976d2' },
    { icon: <FaUsers size={28} />, label: 'Total Absent', value: 3, color: '#d32f2f' },
    { icon: <FaClock size={28} />, label: 'Total Late', value: 2, color: '#fbc02d' }
  ]);

  const [attendanceMenuOpen, setAttendanceMenuOpen] = useState(false);
  const [timeTableMenuOpen, setTimeTableMenuOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [sidebarFullscreen, setSidebarFullscreen] = useState(false);
  const [examMenuOpen, setExamMenuOpen] = useState(false);
  const [homeworkMenuOpen, setHomeworkMenuOpen] = useState(false);
  const [questionsMenuOpen, setQuestionsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();
  const componentRef = useRef();
  const { user, loading } = useAuth();

  // Effects
  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate('/', { replace: true });
      return;
    }
    setAdminName(user.displayName || user.email);
  }, [user, loading, navigate]);

  // Animate counts on mount or refresh
  useEffect(() => {
    const targets = { students: 21, employees: 14, courses: 6, batches: 18 };
    let frame = 0;
    const totalFrames = 40; // Animation speed
    function animate() {
      frame++;
      setCounts({
        students: Math.round(targets.students * frame / totalFrames),
        employees: Math.round(targets.employees * frame / totalFrames),
        courses: Math.round(targets.courses * frame / totalFrames),
        batches: Math.round(targets.batches * frame / totalFrames),
      });
      if (frame < totalFrames) requestAnimationFrame(animate);
      else setCounts(targets);
    }
    animate();
  }, []);

  // Fetch attendance data
  useEffect(() => {
    const db = getFirestore();
    
    // Fetch student attendance
    const studentAttendanceRef = collection(db, 'attendance');
    const studentQuery = query(studentAttendanceRef, where('date', '==', new Date().toISOString().slice(0, 10)));
    
    onSnapshot(studentQuery, (snapshot) => {
      const studentStats = {
        present: 0,
        absent: 0,
        late: 0
      };
      
      snapshot.docs.forEach(doc => {
        const data = doc.data();
        if (data.status === 'Present') studentStats.present++;
        else if (data.status === 'Absent') studentStats.absent++;
        else if (data.status === 'Late') studentStats.late++;
      });
      
      setAttendanceSummary(prev => prev.map(item => {
        if (item.label === 'Total Students Present') return { ...item, value: studentStats.present };
        if (item.label === 'Total Absent') return { ...item, value: studentStats.absent };
        if (item.label === 'Total Late') return { ...item, value: studentStats.late };
        return item;
      }));
    });
    
    // Fetch teacher attendance
    const teacherAttendanceRef = collection(db, 'teacherAttendance');
    const teacherQuery = query(teacherAttendanceRef, where('date', '==', new Date().toISOString().slice(0, 10)));
    
    onSnapshot(teacherQuery, (snapshot) => {
      const teacherPresent = snapshot.docs.filter(doc => doc.data().status === 'Present').length;
      
      setAttendanceSummary(prev => prev.map(item => {
        if (item.label === 'Total Teachers Present') return { ...item, value: teacherPresent };
        return item;
      }));
    });
  }, []);

  // Fetch timetable data
  useEffect(() => {
    const db = getFirestore();
    
    // Fetch student timetables
    const studentTimetableRef = collection(db, 'studentTimetables');
    onSnapshot(studentTimetableRef, (snapshot) => {
      const studentTimetableCount = snapshot.docs.length;
      
      setTimeTableSummary(prev => prev.map(item => {
        if (item.label === 'Student TimeTables') return { ...item, value: studentTimetableCount };
        return item;
      }));
    });
    
    // Fetch teacher timetables
    const teacherTimetableRef = collection(db, 'teacherTimetables');
    onSnapshot(teacherTimetableRef, (snapshot) => {
      const teacherTimetableCount = snapshot.docs.length;
      
      setTimeTableSummary(prev => prev.map(item => {
        if (item.label === 'Teacher TimeTables') return { ...item, value: teacherTimetableCount };
        return item;
      }));
    });
  }, []);

  const PrintableIDCard = React.forwardRef(function PrintableIDCard(props, ref) {
    const s = props.student;
    if (!s) return null;
    return (
      <div ref={ref} style={{
        width: 340,
        minHeight: 210,
        border: '2px solid #1976d2',
        borderRadius: 18,
        background: 'linear-gradient(135deg, #fff 60%, #1976d2 100%)',
        boxShadow: '0 4px 24px rgba(25,118,210,0.10)',
        padding: 24,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 18,
        fontFamily: 'inherit'
      }}>
        <div style={{
          width: 90,
          height: 110,
          borderRadius: 12,
          overflow: 'hidden',
          border: '3px solid #1976d2',
          background: '#f5f7fa',
          boxShadow: '0 2px 8px #1976d233',
          flexShrink: 0
        }}>
          <img
            src={s.imageFilename ? `http://localhost:5000/images/${s.imageFilename}` : '/assets/default-avatar.png'}
            alt={s.studentName}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 800, fontSize: 22, color: '#1976d2', marginBottom: 2 }}>{s.studentName}</div>
          <div style={{ color: '#555', fontSize: 15, marginBottom: 2 }}>Roll No: <b>{s.id}</b></div>
          <div style={{ color: '#555', fontSize: 15, marginBottom: 2 }}>Class: <b>{s.grade}</b></div>
          <div style={{ color: '#555', fontSize: 15, marginBottom: 2 }}>DOB: <b>{s.dateOfBirth}</b></div>
          <div style={{ color: '#555', fontSize: 15, marginBottom: 2 }}>Gender: <b>{s.gender}</b></div>
          <div style={{ color: '#555', fontSize: 15, marginBottom: 2 }}>Parent: <b>{s.parentName}</b></div>
          <div style={{ color: '#555', fontSize: 15, marginBottom: 2 }}>Phone: <b>{s.phone}</b></div>
          <div style={{ color: '#555', fontSize: 15, marginBottom: 2 }}>Email: <b>{s.email}</b></div>
          <div style={{
            marginTop: 10,
            fontSize: 12,
            color: '#1976d2',
            opacity: 0.7,
            fontWeight: 700
          }}>
            SchoolERP ID Card
          </div>
        </div>
      </div>
    );
  });

  const sectionComponents = {
    Dashboard: ({ summaryCards }) => (
      <>
        {/* Summary Cards */}
        <Row className="g-4" style={{ marginBottom: 24 }}>
          {summaryCards.map((c, i) => (
            <Col xs={12} sm={6} md={3} key={i} style={{ display: 'flex' }}>
              <Card style={{
                borderRadius: 14,
                background: c.color,
                color: '#fff',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                minHeight: 90,
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center',
                padding: 0,
                width: '100%',
                minWidth: 0
              }}>
                <div style={{ padding: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{c.icon}</div>
                <Card.Body style={{ padding: 12, flex: 1 }}>
                  <Card.Title style={{ fontWeight: 700, fontSize: 22, wordBreak: 'break-word' }}>{c.animatedValue}</Card.Title>
                  <Card.Text style={{ color: '#fff', fontSize: 15, wordBreak: 'break-word' }}>{c.label}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {/* Center Content */}
        <Row className="g-4">
          <Col xs={12} md={8}>
            <Card style={{
              borderRadius: 14,
              minHeight: 340,
              marginBottom: 24,
              width: '100%',
              minWidth: 0
            }}>
              <Card.Body>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 16 }}>Daily Attendance Overview (May)</div>
                <div style={{ height: 220, width: '100%', minWidth: 0 }}>
                  <Bar data={chartData} options={chartOptions} />
                </div>
              </Card.Body>
            </Card>
            <Card style={{
              borderRadius: 14,
              minHeight: 220,
              width: '100%',
              minWidth: 0
            }}>
              <Card.Body>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 16 }}>Task Manager</div>
                <div style={{ overflowX: 'auto' }}>
                  <Table responsive hover size="sm" style={{ background: '#fff', borderRadius: 10, minWidth: 500 }}>
                    <thead>
                      <tr style={{ background: '#f5f7fa' }}>
                        <th>Task Description</th>
                        <th>Priority</th>
                        <th>Task Date</th>
                        <th>Status</th>
                        <th>User</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tasks.map((t, i) => (
                        <tr key={i}>
                          <td>{t.desc}</td>
                          <td><span style={{ color: t.priority === 'High' ? '#d32f2f' : t.priority === 'Medium' ? '#fbc02d' : '#43a047', fontWeight: 600 }}>{t.priority}</span></td>
                          <td>{t.date}</td>
                          <td><span style={{ color: t.status === 'Done' ? '#43a047' : t.status === 'In Progress' ? '#1976d2' : '#d32f2f', fontWeight: 600 }}>{t.status}</span></td>
                          <td>{t.user}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4}>
            <Card style={{
              borderRadius: 14,
              minHeight: 180,
              marginBottom: 24,
              width: '100%',
              minWidth: 0
            }}>
              <Card.Body>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12 }}>Quick Stats</div>
                <div style={{ display: 'flex', gap: 18, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
                  <FaUserGraduate style={{ color: '#ff7043', fontSize: 28 }} /> <span>Students: 21</span>
                </div>
                <div style={{ display: 'flex', gap: 18, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
                  <FaUsers style={{ color: '#43a047', fontSize: 28 }} /> <span>Employees: 14</span>
                </div>
                <div style={{ display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap' }}>
                  <FaBook style={{ color: '#1976d2', fontSize: 28 }} /> <span>Courses: 6</span>
                </div>
              </Card.Body>
            </Card>
            <Card style={{
              borderRadius: 14,
              minHeight: 180,
              width: '100%',
              minWidth: 0
            }}>
              <Card.Body>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 12 }}>Support</div>
                <div style={{ color: '#1976d2', marginBottom: 8 }}>Need help? Contact admin@school.com</div>
                <Button variant="primary" style={{ borderRadius: 20, fontWeight: 600, marginTop: 8, width: '100%' }}>Contact Support</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    ),
    Students: StudentsManagement,
    Teachers: Teachers,
    Courses: Courses,
    Batches: Batches,
    'New Admission': AdmissionPage,  // Add this line
    Settings: () => <div style={{padding:40}}><h2>Settings</h2><p>Settings and preferences here.</p></div>,
    'Exams': ExamManagement,
    'Create Exam': ExamManagement,
    'Manage Exams': ExamManagement,
    'Results': ExamManagement,
    'Admit Cards': ExamManagement,
    'Homework': HomeworkPage,
    'Assign Homework': HomeworkPage,
    'View Submissions': HomeworkPage,
    'Questions': QuestionsPage,
    'Add Questions': QuestionsPage,
    'Question Bank': QuestionsPage,
    Attendance: (props) => {
      const handleTeacherClick = () => props.setSelectedSection('Teacher Attendance');
      const handleStudentClick = () => props.setSelectedSection('Student Attendance');
      return (
        <div style={{padding: 0}}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 32 }}>
            <h2 style={{ fontWeight: 800, fontSize: 32, color: '#1976d2', letterSpacing: 1 }}>Attendance Dashboard</h2>
            <div style={{ display: 'flex', gap: 16 }}>
              <Button variant="outline-primary" style={{ borderRadius: 20, fontWeight: 600, boxShadow: '0 2px 8px #1976d233' }} onClick={handleTeacherClick}>Teacher Attendance</Button>
              <Button variant="outline-success" style={{ borderRadius: 20, fontWeight: 600, boxShadow: '0 2px 8px #43a04733' }} onClick={handleStudentClick}>Student Attendance</Button>
            </div>
          </div>
          <Row className="g-4" style={{ marginBottom: 24 }}>
            {attendanceSummary.map((c, i) => (
              <Col xs={12} sm={6} md={4} key={`attendance-summary-${i}`}>
                <Card style={{ borderRadius: 18, background: `linear-gradient(135deg, #fff 60%, ${c.color}22 100%)`, color: c.color, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', minHeight: 90, display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 0, border: 'none' }}>
                  <div style={{ padding: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', background: `${c.color}11`, borderRadius: '18px 0 0 18px' }}>{c.icon}</div>
                  <Card.Body style={{ padding: 12 }}>
                    <Card.Title style={{ fontWeight: 800, fontSize: 26 }}>{c.value}</Card.Title>
                    <Card.Text style={{ color: '#333', fontSize: 16 }}>{c.label}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div style={{ marginTop: 32, textAlign: 'center', color: '#888', fontSize: 18, fontWeight: 500 }}>
            Select a section above to manage attendance records in real time.
          </div>
        </div>
      );
    },
    TimeTable: (props) => {
      const handleTeacherClick = () => props.setSelectedSection('Teacher TimeTable');
      const handleStudentClick = () => props.setSelectedSection('Student TimeTable');
      return (
        <div style={{padding: 0}}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 32 }}>
            <h2 style={{ fontWeight: 800, fontSize: 32, color: '#7b1fa2', letterSpacing: 1 }}>Time Table Dashboard</h2>
            <div style={{ display: 'flex', gap: 16 }}>
              <Button variant="outline-primary" style={{ borderRadius: 20, fontWeight: 600, boxShadow: '0 2px 8px #1976d233' }} onClick={handleTeacherClick}>Teacher TimeTable</Button>
              <Button variant="outline-success" style={{ borderRadius: 20, fontWeight: 600, boxShadow: '0 2px 8px #43a04733' }} onClick={handleStudentClick}>Student TimeTable</Button>
            </div>
          </div>
          <Row className="g-4" style={{ marginBottom: 24 }}>
            {timeTableSummary.map((c, i) => (
              <Col xs={12} sm={6} md={4} key={`timetable-summary-${i}`}>
                <Card style={{ borderRadius: 18, background: `linear-gradient(135deg, #fff 60%, ${c.color}22 100%)`, color: c.color, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', minHeight: 90, display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 0, border: 'none' }}>
                  <div style={{ padding: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', background: `${c.color}11`, borderRadius: '18px 0 0 18px' }}>{c.icon}</div>
                  <Card.Body style={{ padding: 12 }}>
                    <Card.Title style={{ fontWeight: 800, fontSize: 26 }}>{c.value}</Card.Title>
                    <Card.Text style={{ color: '#333', fontSize: 16 }}>{c.label}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div style={{ marginTop: 32, textAlign: 'center', color: '#888', fontSize: 18, fontWeight: 500 }}>
            Select a section above to manage time tables in real time.
          </div>
        </div>
      );
    },
    TeacherAttendance,
    StudentAttendance,
    TeacherTimeTable,
    StudentTimeTable,
    TimeTableAnimated: () => {
      // Dummy animated timetable data
      const [day, setDay] = React.useState(0);
      const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const timetable = [
        [
          { time: '08:00-09:00', subject: 'Math', teacher: 'Mr. Sharma' },
          { time: '09:00-10:00', subject: 'Science', teacher: 'Ms. Gupta' },
          { time: '10:00-11:00', subject: 'English', teacher: 'Mr. Khan' },
          { time: '11:00-12:00', subject: 'Computer', teacher: 'Ms. Ritu' },
        ],
        [
          { time: '08:00-09:00', subject: 'English', teacher: 'Mr. Khan' },
          { time: '09:00-10:00', subject: 'Math', teacher: 'Mr. Sharma' },
          { time: '10:00-11:00', subject: 'Science', teacher: 'Ms. Gupta' },
          { time: '11:00-12:00', subject: 'Art', teacher: 'Ms. Neha' },
        ],
        [
          { time: '08:00-09:00', subject: 'Science', teacher: 'Ms. Gupta' },
          { time: '09:00-10:00', subject: 'Math', teacher: 'Mr. Sharma' },
          { time: '10:00-11:00', subject: 'English', teacher: 'Mr. Khan' },
          { time: '11:00-12:00', subject: 'Sports', teacher: 'Coach Amit' },
        ],
        [
          { time: '08:00-09:00', subject: 'Math', teacher: 'Mr. Sharma' },
          { time: '09:00-10:00', subject: 'Science', teacher: 'Ms. Gupta' },
          { time: '10:00-11:00', subject: 'English', teacher: 'Mr. Khan' },
          { time: '11:00-12:00', subject: 'Music', teacher: 'Ms. Swati' },
        ],
        [
          { time: '08:00-09:00', subject: 'English', teacher: 'Mr. Khan' },
          { time: '09:00-10:00', subject: 'Math', teacher: 'Mr. Sharma' },
          { time: '10:00-11:00', subject: 'Science', teacher: 'Ms. Gupta' },
          { time: '11:00-12:00', subject: 'Computer', teacher: 'Ms. Ritu' },
        ],
        [
          { time: '08:00-09:00', subject: 'Sports', teacher: 'Coach Amit' },
          { time: '09:00-10:00', subject: 'Math', teacher: 'Mr. Sharma' },
          { time: '10:00-11:00', subject: 'English', teacher: 'Mr. Khan' },
          { time: '11:00-12:00', subject: 'Science', teacher: 'Ms. Gupta' },
        ],
      ];
      React.useEffect(() => {
        const interval = setInterval(() => {
          setDay((d) => (d + 1) % days.length);
        }, 2200);
        return () => clearInterval(interval);
      }, [days.length]);
      return (
        <div style={{padding: 0}}>
          <h2 style={{ fontWeight: 700, marginBottom: 24 }}>Time Table (Animated)</h2>
          <Card style={{ borderRadius: 16, boxShadow: '0 4px 24px rgba(25,118,210,0.10)', marginBottom: 24 }}>
            <Card.Body>
              <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginBottom: 18 }}>
                <span style={{ fontWeight: 700, fontSize: 20, color: '#1976d2', letterSpacing: 1, transition: 'color 0.5s' }}>{days[day]}</span>
                <span style={{ color: '#888', fontSize: 15 }}>(Auto-rotating)</span>
              </div>
              <Table responsive hover size="sm" style={{ background: '#fff', borderRadius: 10, fontSize: 16 }}>
                <thead>
                  <tr style={{ background: '#f5f7fa' }}>
                    <th>Time</th>
                    <th>Subject</th>
                    <th>Teacher</th>
                  </tr>
                </thead>
                <tbody>
                  {timetable[day].map((row, i) => (
                    <tr key={i} style={{ animation: 'fadeIn 0.7s', transition: 'background 0.5s' }}>
                      <td style={{ fontWeight: 600 }}>{row.time}</td>
                      <td>{row.subject}</td>
                      <td>{row.teacher}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
          <style>{`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}</style>
        </div>
      );
    },
    Gallery: AdminGallery,
    Download: Download, // Add Download section component
    Enquiry: AdminEnquiry,
    Certificate: Certificate, // Add this new line
  };

  const handleSidebarClick = (label) => {
    if (label === 'Exams') {
      setExamMenuOpen(!examMenuOpen);
      setSelectedSection('Create Exam');
    } else if (label === 'Homework') {
      setHomeworkMenuOpen(!homeworkMenuOpen);
      setSelectedSection('Assign Homework');
    } else if (label === 'Questions') {
      setQuestionsMenuOpen(!questionsMenuOpen);
      setSelectedSection('Add Questions');
    } else {
      setSelectedSection(label);
    }
    setAttendanceMenuOpen(false);
    setTimeTableMenuOpen(false);
  };

  // For submenu click
  const handleAttendanceSubmenuClick = (subLabel) => {
    setSelectedSection(subLabel);
    setAttendanceMenuOpen(false);
  };
  
  const handleTimeTableSubmenuClick = (subLabel) => {
    setSelectedSection(subLabel);
    setTimeTableMenuOpen(false);
  };

  const handleExamSubmenuClick = (subLabel) => {
    setSelectedSection(subLabel);
  };

  const handleHomeworkSubmenuClick = (subLabel) => {
    setSelectedSection(subLabel);
  };

  const handleQuestionsSubmenuClick = (subLabel) => {
    setSelectedSection(subLabel);
  };

  // summaryCards ko animated value ke sath map karein
  const animatedSummaryCards = summaryCards.map(card => ({
    ...card,
    animatedValue: counts[card.valueKey],
  }));

  // SectionComponent ko pass karein
  let SectionComponent;
  if (selectedSection === 'Dashboard') {
    SectionComponent = () => sectionComponents.Dashboard({ summaryCards: animatedSummaryCards });
  } else if (selectedSection === 'Teacher Attendance') {
    SectionComponent = TeacherAttendance;
  } else if (selectedSection === 'Student Attendance') {
    SectionComponent = StudentAttendance;
  } else if (selectedSection === 'Teacher TimeTable') {
    SectionComponent = TeacherTimeTable;
  } else if (selectedSection === 'Student TimeTable') {
    SectionComponent = StudentTimeTable;
  } else if (selectedSection === 'Attendance') {
    SectionComponent = () => sectionComponents.Attendance({ setSelectedSection });
  } else if (selectedSection === 'TimeTable') {
    SectionComponent = () => sectionComponents.TimeTable({ setSelectedSection });
  } else if (selectedSection === 'Notices') {
    SectionComponent = NoticesBoard; // Show NoticesBoard.jsx when Notices is selected
  } else if (selectedSection === 'Gallery') {
    SectionComponent = AdminGallery;
  } else if (selectedSection === 'Download') {
    SectionComponent = Download; // Render Download page when selected
  } else {
    SectionComponent = sectionComponents[selectedSection] || (() => <div />);
  }

  // Logout handler
  const handleLogout = () => {
    auth.signOut().then(() => {
      window.location.href = '/';
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        background: '#f6f8fa',
        fontFamily: 'Inter, Segoe UI, Roboto, Arial, sans-serif',
        position: 'relative',
        transition: 'background 0.3s'
      }}
    >
      {/* Global & Responsive Styles */}
      <style>{`
        html, body {
          background: #f6f8fa;
        }
        @media (max-width: 1200px) {
          .main-content {
            padding: 1.2rem 0.7rem !important;
          }
        }
        @media (max-width: 900px) {
          aside {
            width: ${sidebarOpen ? '70vw' : '0'} !important;
            min-width: 0 !important;
            position: fixed !important;
            z-index: 10001 !important;
            box-shadow: 2px 0 16px rgba(0,0,0,0.12) !important;
          }
          .main-content {
            padding: 1.2rem 0.5rem !important;
          }
          .topbar {
            flex-direction: column;
            align-items: flex-end;
            gap: 8px;
            padding: 10px 8px;
          }
        }
        @media (max-width: 600px) {
          aside {
            width: ${sidebarOpen ? '100vw' : '0'} !important;
            min-width: 0 !important;
            position: fixed !important;
            z-index: 10001 !important;
            box-shadow: 2px 0 16px rgba(0,0,0,0.18) !important;
          }
          .main-content {
            padding: 0.5rem 0.2rem !important;
          }
          .sidebar-logo {
            font-size: 1.2rem;
            padding: 1rem 0.5rem 0.7rem 1rem;
          }
          .sidebar-link {
            font-size: 15px;
            padding: 10px 16px;
          }
          .sidebar-submenu-link {
            font-size: 14px;
            padding: 8px 18px;
          }
          .topbar {
            flex-direction: column;
            align-items: flex-end;
            gap: 8px;
            padding: 8px 4px;
          }
        }
        @media (max-width: 400px) {
          .main-content {
            padding: 0.2rem 0.05rem !important;
          }
          .sidebar-logo {
            font-size: 1rem;
            padding: 0.7rem 0.3rem 0.5rem 0.7rem;
          }
        }
        ::selection {
          background: #1976d2;
          color: #fff;
        }
        input, select, button, textarea {
          font-family: inherit;
        }
        ::-webkit-scrollbar {
          width: 8px;
          background: #e3e6ea;
        }
        ::-webkit-scrollbar-thumb {
          background: #c3cfe2;
          border-radius: 8px;
        }
        .sidebar-logo {
          font-size: 1.7rem;
          font-weight: 800;
          letter-spacing: 1.5px;
          color: #1976d2;
          background: linear-gradient(90deg, #fff 60%, #1976d2 100%);
          border-radius: 12px 12px 0 0;
          padding: 1.5rem 1rem 1rem 2rem;
          margin-bottom: 0.5rem;
          box-shadow: 0 2px 8px #1976d233;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .sidebar-link {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 14px 28px;
          cursor: pointer;
          font-size: 18px;
          border-radius: 12px;
          margin-bottom: 6px;
          transition: all 0.25s;
          min-height: 48px;
          outline: none;
        }
        .sidebar-link.selected, .sidebar-link:focus, .sidebar-link:hover {
          background: linear-gradient(90deg, #1976d2 0%, #43a047 100%);
          color: #fff !important;
          font-weight: 800;
          border-left: 5px solid #1976d2;
          box-shadow: 0 2px 12px #1976d244;
        }
        .sidebar-link:not(.selected) {
          color: #b0bec5;
          font-weight: 500;
          border-left: 5px solid transparent;
        }
        .sidebar-submenu {
          background: linear-gradient(90deg, #fff 60%, #1976d2 100%);
          border-radius: 10px;
          margin-left: 18px;
          margin-top: 2px;
          margin-bottom: 2px;
          box-shadow: 0 2px 8px #1976d222;
          overflow: hidden;
          transition: all 0.2s;
        }
        .sidebar-submenu-link {
          padding: 12px 36px;
          cursor: pointer;
          font-size: 17px;
          border-radius: 8px;
          margin-bottom: 2px;
          transition: all 0.2s;
          outline: none;
        }
        .sidebar-submenu-link.selected, .sidebar-submenu-link:focus, .sidebar-submenu-link:hover {
          background: rgba(25,118,210,0.10);
          color: #1976d2;
          font-weight: 700;
          border-left: 4px solid #1976d2;
        }
        .sidebar-submenu-link:not(.selected) {
          color: #333;
          font-weight: 500;
          border-left: 4px solid transparent;
        }
        .topbar {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: 16px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 8px #1976d233;
          padding: 10px 18px;
          min-height: 56px;
        }
        .topbar span {
          font-weight: 600;
          color: #1976d2;
          margin-right: 12px;
        }
        .topbar .icon {
          font-size: 22px;
          margin-right: 18px;
          cursor: pointer;
        }
        .topbar .logout {
          color: #d32f2f;
          transition: transform 0.2s;
        }
        .topbar .logout:active {
          transform: scale(0.85);
        }
        .main-content {
          flex: 1;
          padding: 2rem 2.5rem;
          background: linear-gradient(135deg, #f6f8fa 0%, #e3e6ea 100%);
          margin-left: ${sidebarFullscreen ? 0 : undefined};
          transition: margin-left 0.4s cubic-bezier(.77,0,.18,1);
          filter: ${sidebarFullscreen ? 'blur(2px) grayscale(0.2)' : 'none'};
          pointer-events: ${sidebarFullscreen ? 'none' : 'auto'};
          min-height: 100vh;
          overflow-x: auto;
        }
      `}</style>
      {/* Sidebar */}
      <aside
        style={{
          width: sidebarFullscreen ? '100vw' : (sidebarOpen ? 240 : 0),
          background: 'linear-gradient(135deg, #222d32 80%, #1976d2 100%)',
          color: '#fff',
          minHeight: '100vh',
          boxShadow: '2px 0 8px rgba(0,0,0,0.04)',
          position: sidebarFullscreen ? 'fixed' : 'relative',
          left: 0,
          top: 0,
          zIndex: sidebarFullscreen ? 9999 : 1,
          transition: 'width 0.4s cubic-bezier(.77,0,.18,1), box-shadow 0.3s',
          overflow: 'hidden',
          borderRight: '1px solid #e3e6ea'
        }}
      >
        <div
          className="sidebar-logo"
          onClick={() => setSidebarOpen(o => !o)}
          onDoubleClick={() => setSidebarFullscreen(f => !f)}
          title="Click to toggle sidebar, double-click for fullscreen"
          tabIndex={0}
        >
          <FaBars /> Admin Panel
        </div>
        <nav style={{ marginTop: 24, opacity: sidebarOpen || sidebarFullscreen ? 1 : 0, transition: 'opacity 0.3s' }}>
          {sidebarLinks.map((l, i) => (
            <div key={i}>
              <div
                className={`sidebar-link${selectedSection === l.label ||
                  (l.label === 'Attendance' && (selectedSection === 'Teacher Attendance' || selectedSection === 'Student Attendance')) ||
                  (l.label === 'TimeTable' && (selectedSection === 'Teacher TimeTable' || selectedSection === 'Student TimeTable')) ||
                  (l.label === 'Exams' && ['Create Exam', 'Manage Exams', 'Results', 'Admit Cards'].includes(selectedSection)) ||
                  (l.label === 'Homework' && ['Assign Homework', 'View Submissions'].includes(selectedSection)) ||
                  (l.label === 'Questions' && ['Add Questions', 'Question Bank'].includes(selectedSection))
                  ? ' selected' : ''}`}
                onClick={() => handleSidebarClick(l.label)}
                tabIndex={0}
                aria-label={l.label}
              >
                {l.icon} {l.label}
                {l.submenu && (
                  <span style={{ 
                    marginLeft: 'auto', 
                    fontSize: 16, 
                    transition: 'transform 0.2s', 
                    transform: ((l.label === 'Attendance' && attendanceMenuOpen) || 
                              (l.label === 'TimeTable' && timeTableMenuOpen) ||
                              (l.label === 'Exams' && examMenuOpen) ||
                              (l.label === 'Homework' && homeworkMenuOpen) ||
                              (l.label === 'Questions' && questionsMenuOpen)) 
                              ? 'rotate(180deg)' : 'none' 
                  }}>
                  {((l.label === 'Attendance' && attendanceMenuOpen) || 
                    (l.label === 'TimeTable' && timeTableMenuOpen) ||
                    (l.label === 'Exams' && examMenuOpen) ||
                    (l.label === 'Homework' && homeworkMenuOpen) ||
                    (l.label === 'Questions' && questionsMenuOpen)) 
                    ? '\u25B2' : '\u25BC'}
                </span>
                )}
              </div>
              {l.submenu && ((l.label === 'Attendance' && attendanceMenuOpen) || 
                            (l.label === 'TimeTable' && timeTableMenuOpen) ||
                            (l.label === 'Exams' && examMenuOpen) ||
                            (l.label === 'Homework' && homeworkMenuOpen) ||
                            (l.label === 'Questions' && questionsMenuOpen)) && (
                <div className="sidebar-submenu">
                  {l.submenu.map((s, si) => (
                    <div
                      key={si}
                      className={`sidebar-submenu-link${selectedSection === s.label ? ' selected' : ''}`}
                      onClick={() => {
                        if (l.label === 'Attendance') handleAttendanceSubmenuClick(s.label);
                        else if (l.label === 'TimeTable') handleTimeTableSubmenuClick(s.label);
                        else if (l.label === 'Exams') handleExamSubmenuClick(s.label);
                        else if (l.label === 'Homework') handleHomeworkSubmenuClick(s.label);
                        else if (l.label === 'Questions') handleQuestionsSubmenuClick(s.label);
                      }}
                      tabIndex={0}
                      aria-label={s.label}
                    >
                      {s.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </aside>
      {/* Fullscreen close button */}
      {sidebarFullscreen && (
        <div
          onClick={() => setSidebarFullscreen(false)}
          style={{
            position: 'fixed',
            top: 24,
            right: 32,
            fontSize: 40,
            color: '#fff',
            cursor: 'pointer',
            zIndex: 10010,
            background: 'rgba(34,45,50,0.98)',
            borderRadius: '50%',
            width: 56,
            height: 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 24px #000a',
            border: '3px solid #fff',
            fontWeight: 900,
            transition: 'background 0.2s, color 0.2s',
            outline: '4px solid #1976d2',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#d32f2f'; e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(34,45,50,0.98)'; e.currentTarget.style.color = '#fff'; }}
          title="Close Fullscreen Sidebar"
          tabIndex={0}
        >
          &times;
        </div>
      )}
      {/* Main Content */}
      <main className="main-content">
        {/* Topbar */}
        <div className="topbar">
          <FaBell className="icon" style={{ color: '#1976d2' }} aria-label="Notifications" tabIndex={0} />
          <span>{adminName ? adminName : 'Admin'}</span>
          <FaSignOutAlt className="icon logout" title="Logout" onClick={handleLogout} tabIndex={0} aria-label="Logout" />
        </div>
        <SectionComponent summaryCards={animatedSummaryCards} setSelectedSection={setSelectedSection} />
      </main>
      {/* Overlay for fullscreen sidebar */}
      {sidebarFullscreen && (
        <div
          onClick={() => setSidebarFullscreen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.18)',
            zIndex: 9998,
            cursor: 'pointer',
          }}
        />
      )}
    </div>
  );
};

export default AdminDashboard;

// No code change needed in this file for the permission error.
// The error "Missing or insufficient permissions" is a Firestore security rules issue.
// See below for the solution.
// No code change needed in this file for the permission error.
// The error "Missing or insufficient permissions" is a Firestore security rules issue.
// See below for the solution.
